var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
// @ts-ignore
import gql from "graphql-tag";
import { CommentFragments } from "../../fragments";
export var getCommentWithRepliesByIdQueryCacheConnection = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query GetCommentWithRepliesByIdQuery($commentId: String!) {\n    getCommentWithReplies(commentId: $commentId) @connection(key: \"CommentWithRepliesConnection\", filter: [\"commentId\"]) {\n      ...CommentFragments_commentWithReplies\n    }\n  }\n  ", "\n"], ["\n  query GetCommentWithRepliesByIdQuery($commentId: String!) {\n    getCommentWithReplies(commentId: $commentId) @connection(key: \"CommentWithRepliesConnection\", filter: [\"commentId\"]) {\n      ...CommentFragments_commentWithReplies\n    }\n  }\n  ", "\n"])), CommentFragments.commentWithReplies);
var templateObject_1;
//# sourceMappingURL=CommentWithReplyListCacheConnection.js.map


//////////////////
// WEBPACK FOOTER
// ../controller/dist/modules/comment/CommentWithReplyListCacheConnection.js
// module id = 1309
// module chunks = 0